import { useContext, useEffect, useRef, useState } from 'react'
import { LockFill } from 'react-bootstrap-icons'
import Authentication from '../../../../../libs/api/services/Authentication'
import Questionnaire from '../../../../../libs/api/services/Questionnaire'
import QuestionnaireConfigContext from '../QuestionnaireConfigProvider'

export default function FBuilderSetupType({ title, description, navigation, errors, setValue, values }) {
    const { setActiveQuestionnaire } = useContext(QuestionnaireConfigContext)

    const [configurationName, setConfigurationName] = useState('')
    const [configurations, setConfigurations] = useState([])
    const [mode, setMode] = useState('')
    const newSectionNameRef = useRef()
    const [configuration, setConfiguration] = useState(Object.keys(values).includes('questionnaireId') ? { id: values.questionnaireId } : undefined)
    useEffect(() => {
        title('Form Builder')
        description('Would you like to create a new form or update an existing one')
        // Load Navigation if session started
        if (Object.keys(values).includes('questionnaireId'))
            navigation([
                { text: 'Remove', type: 'Action', action: async () => { _handleRemoveTemplate(values.questionnaireId).then((r) => { navigation([]); loadConfigs() }) } },
                { text: 'Update', type: 'Next', action: async () => { setValue({ 'questionnaireId': values.questionnaireId }) } },
            ])
        else
            navigation([])

        setValue({ section: undefined })
    }, [])

    const loadConfigs = () => _handleSetSelection('Approved')
    // {
    //     Questionnaire
    //         .ListQuestionnairesByType('Form')
    //         .then((r) =>
    //             setConfigurations(r)).catch((e) => errors(e.message))
    // }

    const _handleSetSelection = (e) => {
        Questionnaire
            .ListQuestionnairesByTypeOpts(e === 'System Surveys' ? 'System' : 'Form', {
                isApproved: e === 'Approved',
                isAlocate: Authentication.getFacility() !== '-1'
            })
            .then((r) =>
                setConfigurations(r)).catch((e) => errors(e.message))
        setMode('Update')
    }
    useEffect(() => {
        loadConfigs()
    }, [])

    const _handleSetConfigrationName = (c) => {
        setConfigurationName(c)
        if (c)
            navigation([{
                text: 'Next', type: 'Next', action: async () => {
                    return await Questionnaire
                        .CreateQuestionnaire({
                            name: c,
                            type: "Form"
                        }).then((r) => {
                            setValue({ 'questionnaireId': r.id, 'questionnaire': c })
                        })
                }
            }])
        else
            navigation([])
        setConfiguration()
    }

    const _handleSetConfigrationNameEvents = (e) => {
        if (e.keyCode === 13) {
            newSectionNameRef.current.blur()
        }
        else if (e.keyCode === 27) {
            newSectionNameRef.current.blur()
            setMode('')
        }
    }

    const _handleRemoveTemplate = async (id) => {
        await Questionnaire
            .RemoveQuestionnaire(id)
    }

    const _handleSelectConfiguration = (c) => {
        setActiveQuestionnaire(c, () => _handleSetSelection('Awaiting Approval'))
        if (c)
            if (c.isLocked)
                navigation([
                    //   { text: 'Remove', type: 'Action', action: async () => { _handleRemoveTemplate(c.id).then((r) => { navigation([]); loadConfigs() }) } },
                    { text: 'Update', type: 'Next', action: async () => { setValue({ 'questionnaireId': c.id, 'templateName': c.name }) } },
                ])
            else
                navigation([
                    { text: 'Remove', type: 'Action', action: async () => { _handleRemoveTemplate(c.id).then((r) => { navigation([]); loadConfigs() }) } },
                    { text: 'Update', type: 'Next', action: async () => { setValue({ 'questionnaireId': c.id, 'templateName': c.name }) } },
                ])
        setConfigurationName('')
        setConfiguration(c)
    }

    return (
        <div className='config-setup-type'>
            <div className={'row top p-3 flex-shrink-1 shadow rounded bg-primary-container '.concat(mode !== 'New' && configurationName === '' ? 'opacity-75' : '')} >
                <div className='col-12'>
                    <h3>New?</h3>
                    <p>Enter a name for the form eg:  Chronic Medication Form</p>
                    <input
                        ref={newSectionNameRef}
                        onFocus={(e) => setMode('New')}
                        onBlur={(e) => setMode('')}
                        onChange={(e) => _handleSetConfigrationName(e.target.value)}
                        onKeyDown={(e) => _handleSetConfigrationNameEvents(e)}
                        value={configurationName}
                        className='form-control' placeholder='Name of the new form eg: Chronic Medication Form' />
                </div>
            </div>
            <div className={'row bottom p-3 flex-grow-1 shadow mb-3 rounded bg-secondary-container '.concat(mode !== 'New' && configuration ? '' : ' opacity-75')}>
                <div className='col-12' style={{ height: 'calc(100% - 30px)' }}>
                    <h3>Update Existing?</h3>
                    <p>Select the form you would like to update</p>
                    <SectionSelectorTabs onChange={_handleSetSelection} />
                    <div
                        style={{ cursor: 'pointer', maxHeight: '75%', overflow: 'auto' }}
                        className='text-start'>
                        {
                            configurations.map((c) =>
                                <div
                                    className={'p-2 rounded '.concat(configuration && c.id === configuration.id ? ' font-weight-bold active ' : ' font-weight-light ')}
                                    onClick={() => _handleSelectConfiguration(c)} >{c.isLocked ? <LockFill className='me-2' /> : <></>}
                                    <div className='flex-grow-1'>{c.name}</div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const SectionSelectorTabs = ({ onChange }) => {
    const [selected, setSelected] = useState({ opt: 'Approved' })
    const Options = [
        { opt: 'Approved', hr: 'Approved' },
        { opt: 'Awaiting Approval', hr: 'Awaiting Approval' },
        { opt: 'System Surveys', hr: 'System Surveys', super: true },
    ]
    useEffect(() => { if (selected && onChange) onChange(selected.opt) }, [selected])
    return (<div className='d-flex'>
        {Options.map(o =>
            Authentication.getFacility() === '-1' && o.super ?
                <button onClick={e => setSelected(o)} className={`btn shadow-none rounded-3 w-100 tab ${selected && selected.opt === o.opt ? 'selected shadow ' : ''}`}>{o.hr}</button>
                :
                Authentication.getFacility() !== '-1' && o.super ?
                    <></>
                    :
                    <button onClick={e => setSelected(o)} className={`btn shadow-none w-100 tab ${selected && selected.opt === o.opt ? 'selected shadow ' : ''}`}>{o.hr}</button>
        )
        }
    </div >)
}